/** **************** HELPER FUNCTIONS ***************** */
const envVariables = ((env = 'local') => {
  const variables = {
    default: {
      // DEFAULT VALUES
      HACKERS_MIND_PARTICIPANT_GUIDE_URL:
        'https://docs.google.com/document/d/1MmPOoMwLDRby1mAorqk-HxikVrlBlhxrQbkm72cVYIc/edit',
      SAMPLE_ROOM_SCHEDULE_URL:
        'https://docs.google.com/spreadsheets/d/1KTQBPiDZJfVMLL3emTJz4LKuuNC92AlyzvwEkeoRv9E',
      SAMPLE_EMPLOYEE_TEMPLATE_v0_URL:
        'https://docs.google.com/spreadsheets/d/14MVKOP3akegHDv-_qrfevskD4t4oOqDjU1LrLv_yQZY',
      SAMPLE_EMPLOYEE_TEMPLATE_v1_URL:
        'https://docs.google.com/spreadsheets/d/1N5Gf_mxWGYQb5_7dlDuJmNTOlR1nCbaWLnCkiBxG_xE',
      HELP_URL: 'https://elevate-security.stoplight.io/',
      GA_DEBUG: false,
      TYPE_FORM_HEALTH_CHECK_URL: 'https://fv5fyw3p7k8n.statuspage.io/api/v2/status.json'
    },
    // ENVIRONMENT SPECIFIC VALUES
    local: {
      APP_URL: 'https://elevate.localtest.me/',
      PHISH_URL: 'https://reflex.localtest.me/ep-login',
      DARKLY: '5ccb130a5d31e5082bfb8b99',
      GA_TRACKING_ID: 'UA-101159963-4',
      GTM_TRACKING_ID: 'GTM-NRNDH8L',
      FULL_STORY_ORG_ID: '13MNP3',
      SLACK_CLIENT_ID: '78093754401.4002967996135',
      MS_TEAMS_APP_ID: 'f0ad6074-95e2-4790-b7db-38edb32d73d5'
    },
    test: {
      APP_URL: 'https://elevate.localtest.me/',
      PHISH_URL: 'https://reflex.elevatesecurity-staging.com/ep-login',
      DARKLY: '',
      GA_TRACKING_ID: '',
      GTM_TRACKING_ID: '',
      FULL_STORY_ORG_ID: '',
      SLACK_CLIENT_ID: '78093754401.4002967996135',
      MS_TEAMS_APP_ID: 'f0ad6074-95e2-4790-b7db-38edb32d73d5'
    },
    review: {
      APP_URL: 'https://elevate.localtest.me/',
      PHISH_URL: 'https://reflex.elevatesecurity-staging.com/ep-login',
      DARKLY: '5cdd6cd3b099aa0814660080',
      GA_TRACKING_ID: 'UA-101159963-4',
      GTM_TRACKING_ID: 'GTM-NRNDH8L',
      FULL_STORY_ORG_ID: '13MNP3',
      SLACK_CLIENT_ID: '78093754401.4002967996135',
      MS_TEAMS_APP_ID: 'f0ad6074-95e2-4790-b7db-38edb32d73d5'
    },
    staging: {
      PHISH_URL: 'https://reflex.elevatesecurity-staging.com/ep-login',
      DARKLY: '5cdd6cd3b099aa0814660080',
      GA_TRACKING_ID: 'UA-101159963-4',
      GTM_TRACKING_ID: 'GTM-NRNDH8L',
      FULL_STORY_ORG_ID: '13MNP3',
      SLACK_CLIENT_ID: '78093754401.4002967996135',
      MS_TEAMS_APP_ID: '503ca9b5-638d-4133-bf7c-d5dcc49422bc'
    },
    prod: {
      PHISH_URL: 'https://phish.elevatesecurity.com/ep-login',
      DARKLY: '5ccb130a5d31e5082bfb8b9a',
      GA_TRACKING_ID: 'UA-101159963-3',
      GTM_TRACKING_ID: 'GTM-MZPM55Q',
      FULL_STORY_ORG_ID: '13MNP3',
      SLACK_CLIENT_ID: '78093754401.4002967996135',
      MS_TEAMS_APP_ID: '2db02a9f-8160-4957-ab5f-11793d570cef'
    }
  }
  // eslint-disable-next-line prefer-object-spread
  return Object.assign({}, variables.default, variables[env])
})(process.env.REACT_APP_ENV)

export default envVariables
